export class AddressRequest {
  public address: string;
}
